import script from "./CabeceraCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CabeceraCard.vue?vue&type=script&setup=true&lang=js"

import "./CabeceraCard.vue?vue&type=style&index=0&id=0689d9e0&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0689d9e0"]])

export default __exports__